/* ============================================================================
   Speed Suspects — 80s CRT terminal boot screen
   Self-contained: injects its own styles + overlay and plays a short boot
   sequence ONCE per visit (first page load), then fades to reveal the page.
   On every later page in the same visit it does nothing.
   Add to any page with:  <script src="boot.js"></script>  (near top of <body>)
   ============================================================================ */
(function(){
  if (window.__ssBootRan) return; window.__ssBootRan = true;

  // ---- play only on the FIRST load of the site -----------------------------
  // sessionStorage = once per visit. Navigating the site will not replay it.
  // (Swap sessionStorage -> localStorage below to show it only once ever,
  //  so returning visitors never see it again.)
  var BOOT_KEY = 'ssBootPlayed';
  var store = null;
  try { store = window.sessionStorage; } catch (e) { store = null; }
  if (store) {
    try {
      if (store.getItem(BOOT_KEY) === '1') return;   // already played this visit
      store.setItem(BOOT_KEY, '1');
    } catch (e) { /* private mode — just play it */ }
  }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---- styles ----
  var css = ''
  + '#ss-boot{position:fixed;inset:0;z-index:99999;background:#000;color:#46f29a;'
  + 'font-family:"IBM Plex Mono",ui-monospace,Menlo,Consolas,monospace;'
  + 'padding:7vh 8vw;overflow:hidden;display:block;'
  + 'text-shadow:0 0 6px rgba(70,242,154,.55);transition:opacity .5s ease;}'
  + '#ss-boot.ss-off{opacity:0;pointer-events:none;}'
  + '#ss-boot .ss-scan{position:absolute;inset:0;pointer-events:none;'
  + 'background:repeating-linear-gradient(0deg,rgba(0,0,0,0) 0,rgba(0,0,0,0) 2px,rgba(0,0,0,.28) 3px,rgba(0,0,0,0) 4px);}'
  + '#ss-boot .ss-vig{position:absolute;inset:0;pointer-events:none;'
  + 'background:radial-gradient(120% 110% at 50% 50%,transparent 55%,rgba(0,0,0,.7) 100%);}'
  + '#ss-boot .ss-flick{position:absolute;inset:0;pointer-events:none;background:rgba(70,242,154,.018);'
  + 'animation:ssflick .11s steps(2) infinite;}'
  + '@keyframes ssflick{0%{opacity:.3}50%{opacity:.9}100%{opacity:.4}}'
  + '#ss-boot .ss-wrap{position:relative;z-index:2;max-width:760px;font-size:clamp(12px,1.5vw,15px);line-height:1.7;}'
  + '#ss-boot .ss-ln{white-space:pre-wrap;opacity:0;}'
  + '#ss-boot .ss-ln.on{opacity:1;}'
  + '#ss-boot .ss-d{color:#1f6e47;}'
  + '#ss-boot .ss-hi{color:#b9ffd9;}'
  + '#ss-boot .ss-bar{display:inline-block;color:#46f29a;}'
  + '#ss-boot .ss-cur{display:inline-block;width:9px;height:1.05em;background:#b9ffd9;'
  + 'vertical-align:-2px;margin-left:2px;box-shadow:0 0 8px rgba(120,255,180,.6);animation:sscur 1s steps(2) infinite;}'
  + '@keyframes sscur{0%,49%{opacity:1}50%,100%{opacity:0}}'
  + '@media(prefers-reduced-motion:reduce){#ss-boot .ss-flick{display:none;}}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  // ---- overlay DOM (created immediately to cover the page) ----
  var ov = document.createElement('div'); ov.id = 'ss-boot';
  ov.innerHTML = '<div class="ss-wrap" id="ss-boot-wrap"></div>'
    + '<div class="ss-scan"></div><div class="ss-vig"></div><div class="ss-flick"></div>';
  (document.body || document.documentElement).appendChild(ov);
  var wrap = ov.querySelector('#ss-boot-wrap');

  function line(html){ var d=document.createElement('div'); d.className='ss-ln'; d.innerHTML=html; wrap.appendChild(d); return d; }

  // ---- sequence ----
  var SEQ = [
    'SPEED SUSPECTS  v5.1',
    '<span class="ss-d">(c) 2026 Speed Suspects Inc // all systems</span>',
    '&nbsp;',
    'CPU ...... 6 CORE @ 4.77 MHz <span class="ss-hi">OK</span>',
    'MEMORY ... 65536 BYTES <span class="ss-hi">OK</span>',
    'DRIVES ... C: STOREFRONT <span class="ss-hi">OK</span>',
    'UPLINK ... CONNECTED <span class="ss-hi">OK</span>',
    '&nbsp;',
    '> boot speedsuspects.sys'
  ];

  var i = 0, speed = reduce ? 16 : 79;
  function step(){
    if (i < SEQ.length){
      var el = line(SEQ[i]); el.classList.add('on'); i++;
      setTimeout(step, speed);
    } else {
      loadBar();
    }
  }

  function loadBar(){
    var el = line('LOADING <span class="ss-bar" id="ss-bar">[          ]</span> <span id="ss-pct">0%</span>');
    el.classList.add('on');
    var bar = el.querySelector('#ss-bar'), pct = el.querySelector('#ss-pct');
    var p = 0, total = reduce ? 1 : 10;
    var iv = setInterval(function(){
      p++;
      var filled = Math.round(p/total*10);
      bar.innerHTML = '[' + '█'.repeat(filled) + ' '.repeat(10-filled) + ']';
      pct.textContent = Math.min(100, Math.round(p/total*100)) + '%';
      if (p >= total){
        clearInterval(iv);
        var done = line('&nbsp;'); done.classList.add('on');
        var rdy = line('<span class="ss-hi">READY.</span><span class="ss-cur"></span>'); rdy.classList.add('on');
        setTimeout(finish, reduce ? 63 : 273);
      }
    }, reduce ? 32 : 37);
  }

  function finish(){
    ov.classList.add('ss-off');
    setTimeout(function(){ if (ov && ov.parentNode) ov.parentNode.removeChild(ov); }, 560);
  }

  // kick off (slight delay so first frame paints the black screen)
  setTimeout(step, reduce ? 5 : 63);
})();
